import ValidationHandler from './ValidationHandler'

const ErrorHandler = {
    mixins: [ValidationHandler],
    methods: {
        handleErrors(error) {
        	this.error.show = true
            this.error.message = "Something went wrong. Please try again."

            if (error.response.status === 422) {
                this.error.message = 'Please check the higlighted fields'
                this.getValidationErrors(error.response)
            } else if (error.response.status === 419) {
                this.error.message = 'Session Expired. Please refresh the page and try again'
            }else if(!!error.response.data.message) {
                this.error.message = error.response.data.message
            }
        }
    },
    data() {
        return {
            error: {
                show: false,
                header: '',
                message: ''
            }
        }
    }
}

export default ErrorHandler


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/ErrorHandler.js